var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7071 12.2071L20.3552 14.8552C20.7113 15.2113 20.7113 15.7887 20.3552 16.1448C18.43 18.07 15.3821 18.2866 13.204 16.653L11.6286 15.4714C9.88504 14.1638 8.33622 12.615 7.02857 10.8714L5.84701 9.29601C4.21341 7.11788 4.43001 4.06999 6.35523 2.14477C6.71133 1.78867 7.28867 1.78867 7.64477 2.14477L10.2929 4.79289C10.6834 5.18342 10.6834 5.81658 10.2929 6.20711L9.27175 7.22825C9.10946 7.39054 9.06923 7.63846 9.17187 7.84373C10.3585 10.2171 12.2829 12.1415 14.6563 13.3281C14.8615 13.4308 15.1095 13.3905 15.2717 13.2283L16.2929 12.2071C16.6834 11.8166 17.3166 11.8166 17.7071 12.2071Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.815eac28f8b8fd3e3be5f6fc91453704.svg";
export { ForwardRef as ReactComponent };